import React, { useContext } from "react";
import { Button, Icon } from "semantic-ui-react";
import { RootStoreContext } from "../../../app/stores/rootStore";
import ListUsersClient from "./ListUsersClient";
import NewUserClientForm from "./NewUserClientForm";

const DashboardUsersClient = () => {
  const rootStore = useContext(RootStoreContext);
  const { openModal } = rootStore.modalStore;

  return (
    <div className="configurationContent">
        <Button
          onClick={() => openModal(<NewUserClientForm />, "Crear usuario")}
          color="blue"
        >
          <Icon name="add user" /> Agregar Usuario
        </Button>
        <br />
        <br />
        <ListUsersClient />
    </div>
  );
};

export default DashboardUsersClient;
